import type { JSX } from 'react';
import { VideoDetailLayout, type VideoDetailLayoutProps } from './VideoDetailLayout';

/**
 * Visual variants for {@code VideoDetailLayout}. The runtime ships
 * one canonical detail layout; variants are theme-overridable per
 * the {@code resolvePrimitive} contract — when a theme registers a
 * {@code VideoDetailLayout} override, that wins.
 *
 * <p>Current variants are name-only aliases over the default layout
 * — they exist so themes can swap in distinct visual treatments
 * (cinematic vs. compact) without changing call sites. Themes that
 * want richer per-variant rendering ship their own override.
 */
export type VideoDetailVariant = 'standard' | 'cinematic' | 'compact';

export function resolveVideoDetailVariant(
  _variant: VideoDetailVariant | undefined,
): (props: VideoDetailLayoutProps) => JSX.Element | null {
  return VideoDetailLayout;
}
